import {http, onSuccess, onFail} from './http';

export const clientGet = (eventKey) =>
    http.get(`/api/player/event/${eventKey}/login`)
        .then(onSuccess, onFail);

export const checkEmail = (eventKey, data) =>
    http.post(`/api/player/event/${eventKey}/login/email/check_email`, data)
        .then(onSuccess, onFail);

export const checkPhoto = (eventKey, data, params) =>
    http.post(`/api/player/event/${eventKey}/login/email/check_photo`, data, params)
        .then(onSuccess, onFail);

export const registrationByEmail = (eventKey, data) =>
    http.post(`/api/player/event/${eventKey}/login/email/registration`, data)
        .then(onSuccess, onFail);

export const sendSmsCode = (eventKey, data) =>
    http.post(`/api/player/event/${eventKey}/login/email/send_sms_code`, data)
        .then(onSuccess, onFail);

export const loginByPhone = (eventKey, data) =>
    http.post(`/api/player/event/${eventKey}/login/phone`, data)
        .then(onSuccess, onFail);

export const checkAllowedEmail = (eventKey) =>
    http.post(`/api/player/event/${eventKey}/check-allowed-email`)
        .then(onSuccess, onFail);

export const clientRoleCheck = (eventKey) =>
    http.post(`/api/player/event/${eventKey}/client-role/check`)
        .then(onSuccess, onFail);

export const logout = (eventKey) =>
    http.post(`/api/player/event/${eventKey}/logout`)
        .then(onSuccess, onFail);

export const clientUpdate = (eventKey, data) =>
    http.put(`/api/player/event/${eventKey}/login`, data)
        .then(onSuccess, onFail);

export const loginGuest = (eventKey, data) =>
    http.post(`/api/player/event/${eventKey}/login/guest`, data)
        .then(onSuccess, onFail);

export const loginByEmail = (eventKey, data) =>
    http.post(`/api/player/event/${eventKey}/login/email`, data)
        .then(onSuccess, onFail);

export const restorePassword = (eventKey, data) =>
    http.post(`/api/player/event/${eventKey}/login/email/restore`, data)
        .then(onSuccess, onFail);

export const loginWithAccessToken = (eventKey, accessToken) =>
    http.post(`/api/player/event/${eventKey}/login/accessToken`, {accessToken})
        .then(onSuccess, onFail);

export const loginAnonymously = (eventKey, data) =>
    http.post(`/api/player/event/${eventKey}/login/anonymous`, data)
        .then(onSuccess, onFail);

export const loginExternal = (eventKey, data) =>
    http.post(`/api/player/event/${eventKey}/login/external`, data)
        .then(onSuccess, onFail);

export const updateClientRegistration = (eventKey, data) =>
    http.post(`/api/player/event/${eventKey}/client`, data)
        .then(onSuccess, onFail);
